import React from "react";

const Duplicate = (props: any) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.92118 16.3999H0.347504C0.247778 16.3999 0.0483398 16.2999 0.0483398 16.0999V2.99994C0.0483398 2.89994 0.148053 2.69995 0.347504 2.69995H2.64118C2.7409 2.69995 2.9404 2.79994 2.9404 2.99994C2.9404 3.09994 2.84063 3.29993 2.64118 3.29993H0.646668V15.8999H9.72171V15.5999C9.72171 15.4999 9.82143 15.2999 10.0209 15.2999C10.1206 15.2999 10.32 15.3999 10.32 15.5999V16.2C10.2203 16.3 10.1206 16.3999 9.92118 16.3999Z"
        fill="black"
      />
      <path
        d="M12.4144 3.99997H9.32285C9.22312 3.99997 9.02368 3.89998 9.02368 3.69998V1.69998C9.02368 1.59998 9.12339 1.39996 9.32285 1.39996C9.5223 1.39996 9.62201 1.49998 9.62201 1.69998V3.39996H12.5141C12.6138 3.39996 12.8132 3.49998 12.8132 3.69998C12.6138 3.89998 12.5141 3.99997 12.4144 3.99997Z"
        fill="black"
      />
      <path
        d="M12.4142 14.1H2.74081C2.64109 14.1 2.44165 14 2.44165 13.8V0.699982C2.44165 0.599982 2.54136 0.399963 2.74081 0.399963H9.32267C9.42239 0.399963 9.4224 0.399969 9.52213 0.499969L12.5139 3.49997C12.5139 3.49997 12.6136 3.59998 12.6136 3.69998V6.29996C12.6136 6.39996 12.5139 6.59998 12.3144 6.59998C12.2147 6.59998 12.0153 6.49996 12.0153 6.29996V3.79996L9.1232 0.899963H3.03998V13.5H12.115V8.19998C12.115 8.09998 12.2147 7.89996 12.4142 7.89996C12.5139 7.89996 12.7134 7.99998 12.7134 8.19998V13.7C12.6136 14 12.5139 14.1 12.4142 14.1Z"
        fill="black"
      />
      <path
        d="M10.5197 6.60001H4.43643C4.33671 6.60001 4.13721 6.49999 4.13721 6.29999C4.13721 6.19999 4.23698 6 4.43643 6H10.5197C10.6194 6 10.8188 6.09999 10.8188 6.29999C10.8188 6.49999 10.7191 6.60001 10.5197 6.60001Z"
        fill="black"
      />
      <path
        d="M10.5197 8.79993H4.43643C4.33671 8.79993 4.13721 8.69994 4.13721 8.49994C4.13721 8.39994 4.23698 8.19995 4.43643 8.19995H10.5197C10.6194 8.19995 10.8188 8.29994 10.8188 8.49994C10.8188 8.59994 10.7191 8.79993 10.5197 8.79993Z"
        fill="black"
      />
      <path
        d="M10.5197 10.8999H4.43643C4.33671 10.8999 4.13721 10.7999 4.13721 10.5999C4.13721 10.4999 4.23698 10.2999 4.43643 10.2999H10.5197C10.6194 10.2999 10.8188 10.3999 10.8188 10.5999C10.8188 10.7999 10.7191 10.8999 10.5197 10.8999Z"
        fill="black"
      />
      <path
        d="M12.3147 17.7999C10.9185 17.7999 9.82153 16.6999 9.82153 15.2999C9.82153 13.8999 10.9185 12.7999 12.3147 12.7999C13.7108 12.7999 14.8078 13.8999 14.8078 15.2999C14.8078 16.6999 13.7108 17.7999 12.3147 17.7999Z"
        fill="#F0F5FF"
      />
      <path
        d="M12.3145 18.2C10.7189 18.2 9.32275 16.9 9.32275 15.2C9.32275 13.6 10.6192 12.2 12.3145 12.2C13.9101 12.2 15.3063 13.5 15.3063 15.2C15.3063 16.9 14.0098 18.2 12.3145 18.2ZM12.3145 12.7999C10.9184 12.7999 9.82138 13.8999 9.82138 15.2999C9.82138 16.6999 10.9184 17.7999 12.3145 17.7999C13.7107 17.7999 14.8077 16.6999 14.8077 15.2999C14.8077 13.8999 13.7107 12.7999 12.3145 12.7999Z"
        fill="black"
      />
      <path
        d="M13.8106 15.3999H10.8188C10.7191 15.3999 10.6194 15.3 10.6194 15.2C10.6194 15.1 10.7191 14.9999 10.8188 14.9999H13.8106C13.9103 14.9999 14.0101 15.1 14.0101 15.2C14.0101 15.3 13.9103 15.3999 13.8106 15.3999Z"
        fill="black"
      />
      <path
        d="M12.3147 16.8999C12.215 16.8999 12.1152 16.8 12.1152 16.7V13.7C12.1152 13.6 12.215 13.4999 12.3147 13.4999C12.4144 13.4999 12.5142 13.6 12.5142 13.7V16.7C12.6139 16.8 12.4144 16.8999 12.3147 16.8999Z"
        fill="black"
      />
    </svg>
  );
};

export default Duplicate;
